// extracted by mini-css-extract-plugin
export default {"chart":"PageSkeleton_chart__Ta+7W","table":"PageSkeleton_table__R3ot2","title":"PageSkeleton_title__SkT1N"};